import Preference from "../UI/Preference";
import Pagination from "../UI/Pagination";
import { getHeaderCounterText, getPagedItems } from "../../utils/common";
import { DEFAULT_PAGE_SIZE } from "../../configs/constants";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  SpaceBetween,
  Header,
} from "@cloudscape-design/components-themed";
import { COMMON_LABELS } from "../default-constants";
import { LABELS } from "./constants";

import CSDTable from "@cloudscape-design/components-themed/table";

const columnDefinitions = [
  {
    id: "merchantBranch",
    header: LABELS.BRANCH,
    cell: (e: any) => (
      <Link
        to={
          "/rate-adjustment-case/merchant/" +
          e.rateAdjustmentCaseNo +
          "/" +
          e.merchantBranchNo
        }
      >
        {e.no}
      </Link>
    ),
  },
  {
    id: "merchantName",
    header: LABELS.MERCHANT_NAME,
    cell: (e: any) => e.merchantName,
  },
  {
    id: "serviceName",
    header: LABELS.SERVICE_NAME,
    cell: (e: any) => e.contractServiceName,
  },
];

export const MerchantTable = (props: any) => {
  const navigate = useNavigate();

  /**ページャ関連 */
  const options = columnDefinitions.map((column) => ({
    id: column.id,
    label: column.header,
  }));
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [preferences, setPreferences] = useState({
    pageSize: DEFAULT_PAGE_SIZE,
    visibleContent: options.map((o) => o.id),
  });

  const [pagedItems, setPagedItems] = useState<Object[]>([]);
  const [allItems, setAllItems] = useState<Object[]>([]);

  useEffect(() => {
    if (props.merchantDetailDataList !== undefined) {
      setPagedItems(
        getPagedItems(props.merchantDetailDataList, 1, DEFAULT_PAGE_SIZE)
      );
      setAllItems(props.merchantDetailDataList);
      setCurrentPageIndex(1);
    }
  }, [props.merchantDetailDataList]);

  /** 設定変更関数 */
  const handleOnConfirm = (detail: any) => {
    const newPageSize = detail.pageSize;
    setPreferences({
      pageSize: newPageSize,
      visibleContent: detail.visibleContent,
    });
    setPagedItems(props.merchantDetailDataList.slice(0, newPageSize));
    setCurrentPageIndex(1);
  };

  if (!props.merchantDetailDataList) return null;

  return (
    <CSDTable
      onSelectionChange={({ detail }) => {
        props.setSelectedItems(detail.selectedItems);
        props.setIsRadioSelected(true);
      }}
      trackBy="no"
      columnDefinitions={columnDefinitions}
      loading={props.isFetching}
      loadingText={COMMON_LABELS.CSD.LOADING_TEXT}
      items={pagedItems}
      resizableColumns
      stickyHeader
      totalItemsCount={13}
      header={
        <SpaceBetween size="xs">
          <Button
            onClick={() => {
              navigate(
                `/rate-adjustment-case/merchant/register/${props.rateAdjustmentCaseNo}`
              );
            }}
          >
            {LABELS.ADD_MERCHANT}
          </Button>
          <Header>
            {LABELS.TABLE_TITLE}
            {getHeaderCounterText(allItems.length, pagedItems.length)}
          </Header>
        </SpaceBetween>
      }
      empty={
        <Box textAlign="center" color="inherit">
          {COMMON_LABELS.CSD.NO_DATA}
        </Box>
      }
      pagination={
        <Pagination
          currentPageIndex={currentPageIndex}
          filteredItems={allItems}
          setCurrentPageIndex={setCurrentPageIndex}
          pageSize={preferences.pageSize}
          setPagedItems={setPagedItems}
        />
      }
      preferences={
        <Preference
          preferences={preferences}
          options={options}
          handleOnConfirm={handleOnConfirm}
        />
      }
    />
  );
};
